<template>
  <a-layout id="admin-layout">
    <a-affix :offset-top="0" style="z-Index:200">
      <a-layout-header class="header">
        <a-row >
          <a-col :span="4">
            <div id="logo" class="logo-wrapper">
              <a href="/" class="router-link-active">
                <img :src="siteInfo.logo" class="logo-image" v-if="siteInfo.logo" />
              </a>
            </div>
          </a-col>
          <a-col :span="20">
            <a-dropdown placement="bottomCenter">
              <div class="header-right">
                <a-avatar
                  :size="34"
                  :src="(userInfo && userInfo.avatar) || avatar"
                  class="header-avatar"
                />
                <span class="header-right-name">{{userInfo && userInfo.name}}</span>
                <div class="header-right-text">
                  <span v-if="userInfo.type==1">{{$t('enum.userType.1')}}</span>
                  <span v-if="userInfo.type==2">{{$t('enum.userType.2')}}</span>
                  <span v-if="userInfo.type==3">{{$t('enum.userType.3')}}</span>
                  <span v-if="userInfo.type==4">{{$t('enum.userType.4')}}</span>
                </div>
              </div>
              <template v-slot:overlay>
                <a-menu class="ant-pro-drop-down menu">
                  <a-menu-item
                    key="center"
                    v-if="userInfo && userInfo.type===1"
                    @click="$router.push({name:'admin-home'})"
                  >
                    <a-icon type="user" />{{$t('common.adminBackground')}}
                  </a-menu-item>
                  <a-menu-item
                    key="center"
                    v-else-if="userInfo && userInfo.type===2"
                    @click="$router.push({name:'agent-home'})"
                  >
                    <a-icon type="user" />{{$t('common.agentBackground')}}
                  </a-menu-item>
                  <a-menu-item
                    @click="$router.push({name:'member-account'})"
                    v-if="userInfo && userInfo.type===3"
                  >
                    <a-icon type="setting" />{{$t('common.memberCenter')}}
                  </a-menu-item>
                  <a-menu-item
                    @click="$router.push({name:'employee-account'})"
                    v-if="userInfo && userInfo.type===4"
                  >
                    <a-icon type="setting" />{{$t('common.memberCenter')}}
                  </a-menu-item>
                  <a-menu-item
                    @click="$router.push({name:'agent-account'})"
                    v-else-if="userInfo && userInfo.type===2"
                  >
                    <a-icon type="setting" />{{$t('common.memberCenter')}}
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item key="logout" @click="onClickLoginout">
                    <a-icon type="logout" />{{$t('common.logout')}}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>

            <a-menu
              mode="horizontal"
              :default-selected-keys="activeTopbarMenu"
              :style="{ lineHeight: '61px', background:'rgba(1, 92, 97)', color: 'rgba(241, 254, 255)', float: 'right'}"
            >
              <a-menu-item
                @click="handleMenuClick"
                :key="resolvePath(employeeRoutes[0].path, route.path)"
                v-for="route in topbarMenus"
              >
                <span>{{$t(`moduleTitles.${route.meta.title}`)}}</span>
              </a-menu-item>

              <a-button type="primary" @click="handlePublishClick">{{$t(`moduleTitles.pcpublish`)}}</a-button>
            </a-menu>
          </a-col>
        </a-row>
      </a-layout-header>
    </a-affix>
    <a-layout style="margin:16px 0;">
      <a-layout-sider
        :style="{  position: 'fixed', left: 0 ,height: 'calc(100vh - 96px )',background:'#fff',}"
        class="sider-block"
      >
        <a-menu
          :default-selected-keys="activeSidebarMenu"
          :selected-keys="activeSidebarMenu"
          :style="{  borderRight: 0, background: '#ffffff' }"
        >
          <a-menu-item
            @click="handleMenuClick"
            :key="resolveSidebarMenuPath(route.path)"
            v-for="route in sidebarMenus"
          >
            <a-icon v-bind:type="route.meta.icon" />
            {{$t(`moduleTitles.${route.meta.title}`)}}
          </a-menu-item>
        </a-menu>
        <div class="storage-wrapper">
          <a-progress :percent="userDetail.progress" :show-info="false" />
          <span class="storage-percent">{{userDetail.g_use_capacity}}G/{{userDetail.g_capacity}}G</span>
          <span class="storage-description">{{$t('descriptions.spaceCapacity')}}</span>
        </div>
      </a-layout-sider>
      <a-layout-content :style="{ marginLeft: '200px' }">
        <a-layout style="padding: 0px 16px 0 16px; min-height: calc(100vh - 96px )">
          <breadcrumb v-if="$route.meta.showBreadcrumb" />
          <a-layout-content>
            <router-view />
          </a-layout-content>
        </a-layout>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import path from "path";
import { mapState } from "vuex";
import { employeeRoutes } from "@/router";
import Breadcrumb from "@/components/Breadcrumb";
import "../assets/css/main.less";
import { getUserInfo } from "@/api/user";

export default {
  name: "MemberLayout",
  components: { Breadcrumb },
  data() {
    return {
      showMenu: true,
      currentUser: {
        name: this.$t('enum.userType.2'),
      },
      employeeRoutes,
      userDetail: {},
      avatar:'/ssr/static/images/default_avatar.jpg',
      uvclogo:'/ssr/static/images/UVClogo.png'
    };
  },
  mounted() {
    getUserInfo().then((res) => {
      this.userDetail = res.data;
    });
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
      userInfo: (state) => state.user.userInfo,
      siteInfo: (state) => state.siteConfig.siteInfo,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
    activeTopbarMenu() {
      return [this.$route.matched[1].path];
    },

    sidebarMenus() {
      let pathArr = this.$route.matched[1].path.split("/");
      let firstRoute = this.employeeRoutes[0].children.find(
        (p) => p.path === pathArr[2]
      );
      return firstRoute.children.filter((p) => {
        return !p.meta.hidden;
      });
    },
    activeSidebarMenu() {
      return [this.$route.matched[2].path];
    },
    topbarMenus() {
      return this.employeeRoutes[0].children.filter(function (item) {
        return !item.hidden;
      });
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    resolvePath(basePath, routePath) {
      return path.resolve(basePath, routePath);
    },
    resolveSidebarMenuPath(routePath) {
      return path.resolve(this.$route.matched[1].path, routePath);
    },
    handleMenuClick({ item, key, keyPath }) {
      this.$router.push(key);
    },
    handlePublishClick() {
      let name = this.$isMobile() ? "mbpublish" : "pcpublish";
      this.$router.push({ name });
    },
    onClickLoginout() {
      this.$store
      .dispatch("logout")
      .then((res) => {
        this.$message.success(res.message);
      })
      .catch((err) => {
        this.$message.error(err);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-layout-header {
  background: rgba(19, 113, 202, 1);
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  color: #ffff;
  border: 0;
}

.ant-menu-horizontal > .ant-menu-item:hover > span,
.ant-menu-horizontal > .ant-menu-submenu:hover > span,
.ant-menu-horizontal > .ant-menu-item-active > span,
.ant-menu-horizontal > .ant-menu-submenu-active > span,
.ant-menu-horizontal > .ant-menu-item-open > span,
.ant-menu-horizontal > .ant-menu-submenu-open > span,
.ant-menu-horizontal > .ant-menu-item-selected > span,
.ant-menu-horizontal > .ant-menu-submenu-selected > span {
  color: #ffff;
  border-bottom: 2px solid #fff;
}

.logo-wrapper {
  position: absolute;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.logo-image {
  width: 160px;
}

.header-right {
  float: right;
  cursor: pointer;
  padding-left: 50px;
  padding-right: 10px;
  margin-left: 50px;
  overflow: hidden;
  color: hsla(0, 0%, 100%, 0.85);
  height: 64px;
  line-height: normal;
  position: relative;
  &:hover {
    background: rgba(0, 0, 0, 0.25);
  }
  // .account-avatar {
  //   width: 24px;
  //   height: 24px;
  //   line-height: 24px;
  // }
  .header-avatar {
    position: absolute;
    top: 15px;
    left: 10px;
  }
  .header-right-name{
    margin-top: 12px;
    display: inline-block;
  }
  .header-right-text{
    color: rgba(255,255,255,.7);
    font-size: 12px;
    margin-top: 3px;
  }
}

.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}

.storage-wrapper {
  height: 50px;
  position: relative;
  padding: 0 10px 0 10px;
  .storage-percent {
    font-size: 14px;
    color: rgb(153, 153, 153);
  }
  .storage-description {
    position: absolute;
    color: rgb(48, 48, 48);
    font-size: 14px;
    right: 10px;
  }
}

.ant-menu-horizontal {
  border: 0;
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  border: 0;
}
.ant-menu-item > span {
  display: inline-block;
  line-height: 35px;
}
.sider-block /deep/ .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 0 20px;
}
.uvcbg{
  background-color: #7101AD;
}
.ant-layout-header{
  background-color: #015c61;
}
</style>
